import {PositionInterface} from '../../../shared/interfaces';
import {CheckboxControl} from '../../../shared/classes/controls';

export class AccountAccessRightControl {
    public position: PositionInterface;
    public control: CheckboxControl;
    public permissionString: string;

    constructor(position: PositionInterface, control: CheckboxControl, permissionString?: string) {
        this.position = position;
        this.control = control;
        this.permissionString = permissionString;
    }
}
